import React from 'react';
import _ from '@dh-fe/translate';
import Image from 'components/Image/Image';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import { getContent } from './AwardsSectionContent';
import style from './AwardsSection.module.scss';

const AwardsSection = () => {
    const { items, button } = getContent();
    const { theme, isOranum } = useTheme();
    return (
        <section className={classnames(style[theme], style.awardsSection)} id="featuresSection">
            <h1 className={style.title}>
                {_`We give you the tools and the traffic.`}
                <br />
                {_`You make it happen!`}
            </h1>
            <h2
                className={style.subtitle}
            >{_`Use the wide range of features we provide to create your best content. With the quality traffic we send directly to your profile you’ll soon start making some serious money!`}</h2>
            <div className={style.content}>
                {items.map((item) =>
                    item.isVisible ? (
                        <div className={style.item} key={item.title}>
                            <Image unCompressed={item.image} webp={item.imageCompress} alt="feature card image" />
                            <div className={style.line} />
                            <div className={style.itemInfo}>
                                <h3>{item.title}</h3>
                                {item.share ? <div className={style.share}>{item.share}</div> : null}
                                <div className={style.text}>{item.text}</div>
                            </div>
                        </div>
                    ) : null,
                )}
            </div>
            {isOranum && <div className={style.buttonContainer}>{button}</div>}
        </section>
    );
};

export default AwardsSection;
